module.exports = __webpack_public_path__ + "img/germany.fc842f4.webp";